import { Inject } from '@angular/core';
import { of } from 'rxjs';
import { HttpClient, HttpInterceptorFn } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ApiToken } from '../models/apiToken';
import { catchError, switchMap } from 'rxjs/operators';
import { CustomAppConfig } from '@upassignations/custom-app-config';

/**
 * Interception des requêtes, si le token existe et est encore valide alors il est ajouté à l'entête de la requête.
 */
export const AuthenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const http = Inject(HttpClient);
  const config = Inject(CustomAppConfig);

  if (!config) {
    throw new Error('You must provide an apConfig');
  }

  const apiToken = localStorage.getItem('apiToken');
  if (!apiToken) {
    return next(req);
  }
  const helper = new JwtHelperService();
  const isExpired = helper.isTokenExpired(apiToken);

  if (!isExpired) {
    const authReq = req.clone({
      headers: req.headers.set('X-Auth-Token', apiToken),
    });
    return next(authReq);
  }

  localStorage.removeItem('apiToken');
  return http
    .get(config.get('apiEndpoint') + '/auth/token', { withCredentials: true })
    .pipe(
      switchMap((token) => {
        // use transformation operator that maps to an Observable<T>
        const api = token as ApiToken;
        localStorage.setItem('apiToken', api.token);
        const newRequest = req.clone({
          headers: req.headers.set('X-Auth-Token', api.token),
        });
        return next(newRequest);
      }),

      catchError((error) => {
        if (error.status === 401) {
          let url = config.get('apiEndpoint') + '/saml/login';
          if (config.get('relayState')) {
            url = `${url}?redirectTo=${config.get('relayState')}`;
          }
          window.location.assign(url);
        }
        return of(error);
      })
    );
};
